<template>
    <ReviewQuote 
        v-if="review && review?.[0]"
        :review="review?.[0]"
    />
</template>

<script setup>
defineProps({
    review: {
        type: Object,
        required: true,
        default: () => {}
    }
});
</script>

<style lang="less">
.vizy-blocks__block[data-type='review'] {
    grid-column: 1/-1;

    @media screen and (min-width: 90rem) {
        margin-inline: calc((100vw - var(--grid-maxWidth-page) - var(--scrollbar-width)) / 2 * -1);
    }
}
</style>
